import axios from '../utils/axios';

export default function fetchManagedRecruitersCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/managed-recruiters-count', { params })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}